<template>
  <div class="education-item">
    <a-media
      class="education-item__image"
      :image="image"
      :alt="title"
      :image-aspect-ratio="aspectRatios.educationCenterNewsPreview"
      :video="video"
      :video-aspect-ratio="aspectRatios.educationCenterNewsPreview"
      :url="generateArticleUrl(article)"
    />

    <a-link :to="generateArticleUrl(article)" class="education-item__title">
      {{ title }}
    </a-link>

    <a-hidden-time-for-crawlers :time="publishedOn" />

    <p class="education-item__tldr">{{ tldr }}</p>

    <div class="education-item__bottom">
      <div class="education-item__time-and-disclaimer-wrapper">
        <a-obfuscated-display-time
          :time="publishedOn"
          class="education-item__time"
        />
        <a-disclaimer
          v-if="showDisclaimer"
          :layout-ordering="$options.consts.disclaimerLayoutOrdering"
        />
      </div>

      <div class="education-item__connect">
        <a-action-icon
          v-for="item in actionIconList"
          v-bind="item.props"
          :key="item.icon"
          :action-icon="item.icon"
          v-on="$listeners"
        />
      </div>
    </div>

    <div class="section-delimiter hide-on-desktop" />
  </div>
</template>

<script>
import { prop } from 'ramda'

import { propValidator, PROP_TYPES } from '@/utils/validators'
import mixins from '@/utils/mixins'
import AMedia from 'shared/AMedia'
import AActionIcon, { ACTION_ICON } from 'shared/AActionIcon'
import { aspectRatios } from 'enums/aspectRatios'
import ADisclaimer from 'shared/ADisclaimer'
import { LAYOUT as DISCLAIMER_LAYOUT } from 'shared/ADisclaimer/enums'
import AObfuscatedDisplayTime from 'shared/PublishTime/AObfuscatedDisplayTime/index.vue'
import AHiddenTimeForCrawlers from 'shared/PublishTime/AHiddenTimeForCrawlers/index.vue'

export default {
  name: 'EducationListItem',
  mixins: [mixins.urlGenerators],
  components: {
    AHiddenTimeForCrawlers,
    AObfuscatedDisplayTime,
    AMedia,
    AActionIcon,
    ADisclaimer
  },
  props: {
    image: propValidator([PROP_TYPES.OBJECT], false),
    video: propValidator([PROP_TYPES.OBJECT], false),
    title: propValidator([PROP_TYPES.STRING]),
    tldr: propValidator([PROP_TYPES.STRING]),
    publishedOn: propValidator([PROP_TYPES.STRING]),
    article: propValidator([PROP_TYPES.OBJECT]),
    showDisclaimer: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  consts: {
    disclaimerLayoutOrdering: [DISCLAIMER_LAYOUT.TOP_RIGHT]
  },
  data() {
    return { aspectRatios }
  },
  computed: {
    postDate() {
      return this.$helper.formatDate.toDefault(this.publishedOn)
    },
    actionIconList() {
      return [
        {
          icon: ACTION_ICON.SHARE,
          props: {
            path: this.generateArticlePath(this.article),
            title: this.title,
            description: this.$helper.parseTldrJSONToText(this.tldr),
            heightAuto: true
          }
        },
        {
          icon: ACTION_ICON.SAVE,
          props: {
            isSaved: this.article.IsSaved,
            id: this.article.Id,
            titleWidth: 45
          }
        }
      ]
    }
  },
  methods: {
    prop
  }
}
</script>

<style lang="scss" scoped>
.education-item {
  width: calc(25% - 30px);
  margin-bottom: 40px;

  @include desktop-lg {
    width: calc(50% - 20px);
  }

  @include mobile {
    width: 100%;
    margin-bottom: 0;
  }

  &__image {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }

  &__title {
    display: inline-block;

    font-size: 18px;
    line-height: 1.17;
    font-weight: bold;
    height: 63px;
    overflow: hidden;
    margin-bottom: 10px;
  }

  &__tldr {
    position: relative;
    font-size: 13px;
    font-weight: bold;
    line-height: 1.38;
    height: 36px;
    overflow: hidden;
    padding-left: 17px;
    margin-bottom: 10px;

    &::before {
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: $c--black;
    }
  }

  &__bottom {
    width: 100%;
    line-height: 35px;
    display: flex;
    justify-content: space-between;
  }

  .education-item__time-and-disclaimer-wrapper {
    display: flex;
    flex-direction: column;
  }

  &__time {
    font-size: 12px;
    max-width: 230px;
    line-height: 1.3;
    margin-right: 10px;
  }

  &__connect {
    width: 90px;
    display: flex;
    justify-content: space-between;
  }

  &__icon {
    margin-left: 20px;
  }
}
</style>
